<template>
    <div>
        <rkm-form ref="RkmForm">
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :fields="fields.convenioMedico"
                        :repository="repositories.cadastro.convenioMedico"
                        :selected-text="model.convenio_medico_nome"
                        label="Convênio médico"
                        v-model="model.convenio_medico_id"
                    >
                        <rkm-input-group-append
                            v-if="authorize('cadastro-convenio-medico-store')"
                            slot="append"
                        >
                            <rkm-button
                                @click="$refs.ModalConvenioMedicoForm.open()"
                                color="primary"
                                title="Cadastrar convênio médico"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :fields="fields.convenioOdontologico"
                        :repository="repositories.cadastro.convenioOdontologico"
                        :selected-text="model.convenio_odontologico_nome"
                        label="Convênio odontológico"
                        v-model="model.convenio_odontologico_id"
                    >
                        <rkm-input-group-append
                            v-if="authorize('cadastro-convenio-odontologico-store')"
                            slot="append"
                        >
                            <rkm-button
                                @click="$refs.ModalConvenioOdontologicoForm.open()"
                                color="primary"
                                title="Cadastrar convênio odontológico"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :fields="fields.planoFunerario"
                        :repository="repositories.cadastro.planoFunerario"
                        :selected-text="model.plano_funerario_nome"
                        label="Plano funerário"
                        v-model="model.plano_funerario_id"
                    >
                        <rkm-input-group-append
                            v-if="authorize('cadastro-plano-funerario-store')"
                            slot="append"
                        >
                            <rkm-button
                                @click="$refs.ModalPlanoFunerarioForm.open()"
                                color="primary"
                                title="Cadastrar plano funerário"
                                v-rkm-tooltip.hover
                            >
                                <rkm-icon icon="plus" />
                            </rkm-button>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.situacoes_familiar_conjugais"
                        label="Situação familiar/conjugal"
                        show-default-option
                        text-field="descricao"
                        v-model="model.situacao_familiar_conjugal_id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.escolaridades"
                        label="Escolaridade"
                        show-default-option
                        text-field="descricao"
                        v-model="model.escolaridade_id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.tipos_sanguineos"
                        label="Tipo sanguíneo"
                        show-default-option
                        text-field="descricao"
                        v-model="model.tipo_sanguineo_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.orientacoes_sexuais"
                        label="Orientação sexual"
                        show-default-option
                        text-field="descricao"
                        v-model="model.orientacao_sexual_id"
                    />
                </rkm-col>
                
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.identidades_genero"
                        label="Identidade de gênero"
                        show-default-option
                        text-field="descricao"
                        v-model="model.identidade_genero_id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-radio-group
                        label="Está empregado atualmente?"
                        v-model="model.esta_empregado_atualmente"
                    >
                        <rkm-form-radio :value="true">SIM</rkm-form-radio>
                        <rkm-form-radio :value="false">NÃO</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-radio-group
                        label="É aposentado e/ou pensionista?"
                        v-model="model.aposentado_pensionista"
                    >
                        <rkm-form-radio :value="true">SIM</rkm-form-radio>
                        <rkm-form-radio :value="false">NÃO</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input-autocomplete
                        :disabled="model.aposentado_pensionista"
                        :fields="fields.ocupacao"
                        :repository="repositories.cadastro.ocupacao"
                        :selected-text="model.ocupacao_descricao"
                        label="Profissão"
                        text-field="descricao"
                        v-model="model.ocupacao_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.faixas_renda"
                        :validations="validations.faixa_renda_id"
                        label="Faixa de renda"
                        show-default-option
                        text-field="descricao"
                        v-model="model.faixa_renda_id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-radio-group
                        label="Utiliza transporte coletivo?"
                        v-model="model.utiliza_transporte_coletivo"
                    >
                        <rkm-form-radio :value="true">SIM</rkm-form-radio>
                        <rkm-form-radio :value="false">NÃO</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-radio-group
                        label="É portador de alguma comorbidade?"
                        v-model="model.portador_alguma_comorbidade"
                    >
                        <rkm-form-radio :value="true">SIM</rkm-form-radio>
                        <rkm-form-radio :value="false">NÃO</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>

                <rkm-col cols="8">
                    <rkm-form-select
                        :disabled="!model.portador_alguma_comorbidade"
                        :options="form.comorbidades"
                        :validations="validations.comorbidade_id"
                        label="Qual?"
                        show-default-option
                        text-field="descricao"
                        v-model="model.comorbidade_id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-radio-group
                        label="É doador de orgão?"
                        v-model="model.doador_orgao"
                    >
                        <rkm-form-radio :value="true">SIM</rkm-form-radio>
                        <rkm-form-radio :value="false">NÃO</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-radio-group
                        label="Pratica algum esporte?"
                        v-model="model.pratica_algum_esporte"
                    >
                        <rkm-form-radio :value="true">SIM</rkm-form-radio>
                        <rkm-form-radio :value="false">NÃO</rkm-form-radio>
                    </rkm-form-radio-group>
                </rkm-col>

                <rkm-col cols="8">
                    <rkm-form-select
                        :disabled="!model.pratica_algum_esporte"
                        :options="form.esportes"
                        :validations="validations.esporte_id"
                        label="Qual?"
                        show-default-option
                        text-field="descricao"
                        v-model="model.esporte_id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalConvenioMedicoForm
            @save="handleConvenioMedicoSave"
            ref="ModalConvenioMedicoForm"
        />

        <ModalConvenioOdontologicoForm
            @save="handleConvenioOdontologicoSave"
            ref="ModalConvenioOdontologicoForm"
        />

        <ModalPlanoFunerarioForm
            @save="handlePlanoFunerarioSave"
            ref="ModalPlanoFunerarioForm"
        />
    </div>
</template>

<script>
// Components.
import ModalConvenioMedicoForm from '@/components/cadastro/convenio-medico/Modal'
import ModalConvenioOdontologicoForm from '@/components/cadastro/convenio-odontologico/Modal'
import ModalPlanoFunerarioForm from '@/components/cadastro/plano-funerario/Modal'

// Mixins.
import {authorization} from '@/mixins'

export default {
    components: {
        ModalConvenioMedicoForm,
        ModalConvenioOdontologicoForm,
        ModalPlanoFunerarioForm,
    },
    computed: {
        fields() {
            return {
                convenioMedico: [
                    {key: 'nome', name: 'cadastro_convenio_medico.nome'},
                ],
                convenioOdontologico: [
                    {key: 'nome', name: 'cadastro_convenio_odontologico.nome'},
                ],
                ocupacao: [
                    {key: 'nome', name: 'cadastro_ocupacao.descricao'},
                ],
                planoFunerario: [
                    {key: 'nome', name: 'cadastro_plano_funerario.nome'},
                ],
            }
        },
        validations() {
            return {
                comorbidade_id: {required: true},
                esporte_id: {required: true},
            }
        },
    },
    inject: ['repositories'],
    methods: {
        handleConvenioMedicoSave(convenioMedico) {
            this.model.convenio_medico_id = convenioMedico.id
            this.model.convenio_medico_nome = convenioMedico.nome
        },
        handleConvenioOdontologicoSave(convenioOdontologico) {
            this.model.convenio_odontologico_id = convenioOdontologico.id
            this.model.convenio_odontologico_nome = convenioOdontologico.nome
        },
        handlePlanoFunerarioSave(planoFunerario) {
            this.model.plano_funerario_id = planoFunerario.id
            this.model.plano_funerario_nome = planoFunerario.nome
        },
        validate() {
            return this.$refs.RkmForm.validate()
        },
    },
    mixins: [authorization],
    props: {
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
    watch: {
        'model.portador_alguma_comorbidade'(value) {
            if (value === false) {
                this.model.comorbidade_id = null
            }
        },
        'model.pratica_algum_esporte'(value) {
            if (value === false) {
                this.model.esporte_id = null
            }
        },
        'model.aposentado_pensionista'(value) {
            if (value === true) {
                this.model.ocupacao_id = null
                this.model.ocupacao_descricao = null
            }
        },
    },
}
</script>